var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "客户面单流水查询",
        width: "1000px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { size: "mini", inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "时间" } },
            [
              _c("yto-date-picker", {
                attrs: {
                  maxRangeVal: 31,
                  clearable: false,
                  editable: false,
                  "picker-options": _vm.pickerOptions,
                  type: "datetimerange",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "default-time": ["00:00:00", "23:59:59"],
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy.MM.dd HH:mm",
                },
                model: {
                  value: _vm.searchForm.queryDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "queryDate", $$v)
                  },
                  expression: "searchForm.queryDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客户编码" } },
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.changeK },
                  model: {
                    value: _vm.searchForm.customerCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customerCode", $$v)
                    },
                    expression: "searchForm.customerCode",
                  },
                },
                _vm._l(_vm.kList, function (item, idx) {
                  return _c("el-option", {
                    key: idx,
                    attrs: {
                      label: item.code + "-" + item.name,
                      value: item.code,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "充值平台" } },
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.changePlat },
                  model: {
                    value: _vm.searchForm.channel,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "channel", $$v)
                    },
                    expression: "searchForm.channel",
                  },
                },
                _vm._l(_vm.curPlatList, function (item, idx) {
                  return _c("el-option", {
                    key: idx,
                    attrs: { label: item.name, value: item.code },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "充值服务" } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.searchForm.segmentCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "segmentCode", $$v)
                    },
                    expression: "searchForm.segmentCode",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "普通", value: "NORMAL" },
                  }),
                  _vm.showCOD
                    ? _c("el-option", {
                        attrs: { label: "COD", value: "SVC-COD" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客户/商家" } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.searchForm.sellerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "sellerId", $$v)
                    },
                    expression: "searchForm.sellerId",
                  },
                },
                [
                  _vm.searchForm.channel === "YTO"
                    ? [
                        _c("el-option", {
                          attrs: {
                            label: _vm.curKInfo.code + "-" + _vm.curKInfo.name,
                            value: _vm.curKInfo.code,
                          },
                        }),
                      ]
                    : _vm._l(_vm.shopList, function (item, idx) {
                        return _c("el-option", {
                          key: idx,
                          attrs: { label: item.shopName, value: item.shopId },
                        })
                      }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "y-mb-10" },
        [
          _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _c("div", [_vm._v("（1）查询期初库存：期初日期之前的面单余额")]),
              _c("div", [
                _vm._v("（2）期初库存时间：查询开始时间最后一次余额变动时间"),
              ]),
              _c("div", [
                _vm._v(
                  "（3）充值量：查询时间内，通过自助充值、或者您合作的网点人工充值、自动充值的电子面单总量"
                ),
              ]),
              _c("div", [_vm._v("（4）撤销量：查实时数据")]),
              _c("div", [
                _vm._v(
                  "（5）解冻量：您在合作网点的账户不欠费或者账户余额高于预警值后，冻结的面单会自动解冻并充值回去"
                ),
              ]),
              _c("div", [
                _vm._v(
                  "（6）查询期末库存：期末库存=期初库存+充值量+回收量+解冻量-使用量-撤销量-回收再使用量（补扣）-二次回收扣除量（客户管家补扣）-冻结量"
                ),
              ]),
              _c("div", [
                _vm._v(
                  "（7）查询期末库存时间：查询结束时间当天最后一次面单余额变动时间"
                ),
              ]),
            ]),
            _c("i", { staticClass: "el-icon-warning y-fc-4C84FF" }),
          ]),
          _c("span", { staticClass: "y-fs-12 y-ml-5 y-f-b" }, [
            _vm._v("面单流水字段说明"),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { border: "", data: _vm.tableData },
        },
        [
          _c("el-table-column", {
            attrs: { label: "客户编码", property: "customerCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "客户名称", property: "customerName" },
          }),
          _c("el-table-column", {
            attrs: { label: "面单类型", property: "channelName" },
          }),
          _c("el-table-column", {
            attrs: { label: "店铺名称", property: "sellerName" },
          }),
          _c("el-table-column", {
            attrs: { label: "查询期初库存时间", property: "startTime" },
          }),
          _c("el-table-column", {
            attrs: { label: "查询期初库存", property: "startQuantity" },
          }),
          _c("el-table-column", {
            attrs: { label: "充值量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.rechargeQuantity <= 0
                      ? _c("span", [_vm._v(_vm._s(scope.row.rechargeQuantity))])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(
                                  scope.row,
                                  "rechargeQuantity"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.rechargeQuantity))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "使用量", property: "useQuantity" },
          }),
          _c("el-table-column", {
            attrs: { label: "回收量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.recycleQuantity <= 0
                      ? _c("span", [_vm._v(_vm._s(scope.row.recycleQuantity))])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(
                                  scope.row,
                                  "recycleQuantity"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.recycleQuantity))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "回收再使用量（补扣）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.recycleReUseQuantity <= 0
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.recycleReUseQuantity)),
                        ])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(
                                  scope.row,
                                  "recycleReUseQuantity"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.recycleReUseQuantity))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "二次回收扣除量（客户管家补扣）" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.secondRecycleQuantity <= 0
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.secondRecycleQuantity)),
                        ])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(
                                  scope.row,
                                  "secondRecycleQuantity"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.secondRecycleQuantity))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "撤销量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.revokeQuantity <= 0
                      ? _c("span", [_vm._v(_vm._s(scope.row.revokeQuantity))])
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(
                                  scope.row,
                                  "revokeQuantity"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.revokeQuantity))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "冻结量", property: "freezeQuantity" },
          }),
          _c("el-table-column", {
            attrs: { label: "解冻量", property: "unFreezeQuantity" },
          }),
          _c("el-table-column", {
            attrs: { label: "查询期末库存", property: "quantity" },
          }),
          _c("el-table-column", {
            attrs: { label: "查询期末库存时间", property: "modifyTime" },
          }),
        ],
        1
      ),
      _vm.showDetail
        ? _c("detailDialog", {
            attrs: {
              curRowInfo: _vm.curRowInfo,
              queryDate: _vm.searchForm.queryDate,
              fromParentVisible: _vm.showDetail,
              detailType: _vm.detailType,
            },
            on: {
              "update:fromParentVisible": function ($event) {
                _vm.showDetail = $event
              },
              "update:from-parent-visible": function ($event) {
                _vm.showDetail = $event
              },
            },
          })
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }